/**
 * Only to be used in WPO optimalisation
 */
import './components/animation';
import './components/intro-block-animated';
import { mediaQuery } from '~/js/helpers';

document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll('section.header-home');
	sections.forEach((section, key) => {

		const iframe = section?.querySelector('[data-video]');
		const background = section?.querySelector('[data-background]');
		const content = section?.querySelector('[data-content]');

		if (!iframe) {
			if (mediaQuery('sm') || mediaQuery('md')) {
				background.style.top = '1rem';
				background.style.width = '100vw';
				background.style.height = content.getBoundingClientRect().height + 225 + 'px';
			}
			return;
		}

		if (mediaQuery('sm') || mediaQuery('md')) {
			background.style.height = content.getBoundingClientRect().height + 100 + 'px';
		}
	});
});